import { css } from '@emotion/css'

export const CustomModalClass = css`
  .ant-modal-content {
    .ant-modal-body {
      padding: 0;
    }
  }
`
